// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1dDNv","checkboxCol":"Table_checkboxCol__DvUA8","emailCol":"Table_emailCol__BAdEb","actionCol":"Table_actionCol__17mN-"};